

const statusList = [
  '560CTL10',
  '560CTL20',
  '560CTL30',
  '560CTL40',
  '560CTL41',
  '560CTL42',
  '560CTL43',
  '560CTL44',
  '560CTL45',
  '560CTL50',
]
const decStatus = [
  'REG',
  '511ACK',
  '511SENT',
  '511REJ',
  '528ACC',
  ...statusList,
  '529ROG',
  '529CLE',
  '582REM',
  '583SENT',
  '583ACK',
  '583REJ',
  '583RCV',
  '509CAN',
  'SUPSENT',
  'SUPACK',
  'SUPRCV',
  'SUPREJ',
  '531REM',
  'AMD',
  'RFI',
  'RRDREM',
  'CRESENT',
  'CREACK',
  'CREREJ',
  'CRERCV',
  '514REJ',
  '513REJ',
  '513RCV',
  '504ACC',
]
export const exitInfoDisabledStatus = '599EXIT'
export const exitInfoDisabledStatusAGS = 'DMSEOG'
export const DMSROG = "DMSROG"
const exitDecStatus = (isDMS) =>
  isDMS
    ? ['529CLE', '529ROG', '583REJ', '582REM', exitInfoDisabledStatus]
    : ['DMSCLE', DMSROG, 'ALTREJ', exitInfoDisabledStatusAGS, 'DMSGER', 'DMSINC', 'DMSRES']

export const exitWarningDecStatus = (isDMS) => {
  return isDMS
    ? {
      '583REJ': {
        name: 'times circle',
        color: 'red',
        decTitle: 'The sent details have been rejected by Customs',
      },
      '582REM': {
        name: 'exclamation triangle',
        color: 'orange',
        decTitle: 'A reminder is received to complete the details',
      },
    }
    : {
      ALTREJ: {
        name: 'times circle',
        color: 'red',
        decTitle: 'The sent details have been rejected by Customs',
      },
      DMSGER: {
        name: 'exclamation triangle',
        color: 'orange',
        decTitle: 'A reminder is received to complete the details',
      },
    }
}

export const SUPDecType = ['B', 'C', 'E', 'F', 'X', 'Y']
export const DMSCRE = "DMSCRE"


export const TransmisisonMapping = (isDMS, shipmentType) => ({
  DEC: { decStatus: isDMS ? ['515CRE', '515REJ'] : [DMSCRE, 'DMSREJ', 'DMSSENT'] },
  SUP: {
    decStatus: isDMS ? ['529ROG', '531REM', 'SUPREJ', 'RRDREM'] : [DMSROG, 'DMSGER', 'SUPREM', 'DMSINC'],
    decType: isDMS ? SUPDecType : null,
  },
  CAN: {
    decStatus: isDMS
      ? [...decStatus, '513SENT', '513ACK']
      : ['CORRCV', 'DMSRCV', 'DMSGPR', 'DMSACC', 'DMSDOC', 'DMSCTL', 'DMSRES', 'ALTSENT', 'ALTACK', 'ALTRCV', 'ALTREJ', 'SUPSENT', 'SUPACK', 'SUPREJ', 'SUPREM', 'SUPREQ', 'CORSENT', 'CORACK', 'CORREJ', 'CORREQ', 'CORRES', 'INVREJ', 'DMSCLE', 'DMSROG', 'DMSINC', 'DMSGER']
  },
  COR: {
    decStatus: isDMS
      ? [...decStatus]
      : ['DMSRCV', 'DMSGPR', 'DMSACC', 'DMSDOC', 'DMSCTL', 'CORREJ', 'CORRCV']
  },
  CRE: {
    decStatus: isDMS
      ? [
        '528ACC',
        ...statusList,
        '529ROG',
        '509CAN',
        'SUPSENT',
        'SUPACK',
        'SUPRCV',
        'SUPREJ',
        '531REM',
        'AMD',
        'RFI',
        'RRDREM',
        'CREREJ',
        '514REJ',
        '513SENT',
        '513ACK',
        '513REJ',
        '513RCV',
        '504ACC',
      ]
      : [],
  },
  EXT: {
    decStatus: exitDecStatus(isDMS),
  },
  PRE: {
    decStatus: isDMS ? [...statusList] : ['DMSRCV', 'DMSREJ', 'DMSDOC', 'DMSCTL'],
    decType: ['D', 'E', 'F'],
  },
})




export const isLastShipmentState = (declarationStatus) => [exitInfoDisabledStatusAGS, "DMSINV", "SUPRES", "ALTREQ", "DMSEXT"].includes(declarationStatus)

export const emergencyProcVisibility = (declarationStatus) => [DMSCRE, "DMSSENT", "DMSREJ", "DMSACC", "DMSDOC", "DMSCTL"].includes(declarationStatus)

